import { AutoCompleteProps } from 'antd';
import { usePaginatedSearch } from 'hooks/usePaginatedSearch';
import { t as trsl } from 'i18next';
import { DossiersUrls } from 'services/api/urls';
import { Company } from 'types/Company';
import { Option } from 'types/Option';

export const defaultSiretOption: Option = {
  value: trsl('global:no_siret'),
  key: 'noData',
};

export const useSearchSiret = ({
  onSearch,
  onSelect,
}: AutoCompleteProps<Company>) => {
  return usePaginatedSearch<Company>({
    dataKey: 'siret',
    url: DossiersUrls.SIRETS,
    mapDataToOptions: (sirets) =>
      sirets.map((siret) => ({
        value: siret.fullResult,
        key: siret.siret,
      })),
    onSearch,
    onSelect: (_, siret) => {
      if (siret) {
        onSelect?.(siret, {
          value: siret.fullResult,
          key: siret.siret,
        });
      }
    },
  });
};
